import { render, staticRenderFns } from "./AdditionalDetails.vue?vue&type=template&id=abac201a&scoped=true&"
import script from "./AdditionalDetails.vue?vue&type=script&lang=js&"
export * from "./AdditionalDetails.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalDetails.vue?vue&type=style&index=0&id=abac201a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abac201a",
  null
  
)

export default component.exports